// removed by extract-text-webpack-plugin
module.exports = {"sectionHeading":"styles__sectionHeading___-denC","section1":"styles__section1___3aLPc","hr":"styles__hr___3-NrL","socialShare":"styles__socialShare___2tGY_","instagramFeed":"styles__instagramFeed___1tJDw"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/styles.css
// module id = n4Bh
// module chunks = 3